/**
 * These keys correspond to different aspects of a user's authentication state.
 */
var AccountServiceEnum;
(function (AccountServiceEnum) {
    /**
     * Used for authentication to access the DEXF / Save API.
     * The application receives an access token after a user successfully authenticates and authorizes access.
     */
    AccountServiceEnum["accessToken"] = "accessToken";
    /**
     * A value received from the server during OAuth 2.0 PKCE flow to verify the client
     * making the request is the one who initiated the authorization process.
     */
    AccountServiceEnum["codeVerifier"] = "codeVerifier";
    /**
     * ID Tokens are a standardized feature of OpenID Connect designed to provide the client application with
     * information about the authenticated user. It contains user profile information in the form of claims,
     * in our case it contains the user's display name.
     */
    AccountServiceEnum["idToken"] = "idToken";
    /**
     * PKCE (Proof Key for Code Exchange) is an OAuth 2.0 security extension that mitigates code interception attacks
     * by using a client-generated cryptographic key to link the authorization and token requests.
     */
    AccountServiceEnum["pkce"] = "pkce";
    /**
     * Key indicating the status of authentication. True when an authentication attempt is in progress.
     */
    AccountServiceEnum["authenticationInProgress"] = "authenticationInProgress";
})(AccountServiceEnum || (AccountServiceEnum = {}));
export default AccountServiceEnum;
//# sourceMappingURL=AccountServiceEnum.js.map